export default __webpack_public_path__ + "static/media/reqCall.ba079cf9.svg";